import { useCallback } from 'react';
import { isType } from 'variant';
import { ComponentType } from '@wix/dev-center-client';
import type { AppComponents } from '@wix/dev-center-client';
import { useProjectModel } from '../../model.js';
import { DevCenterComponent } from '../../dev-center/components/dev-center-component.js';

export function useBlocksComponentsMigration() {
  const { model } = useProjectModel();

  const virtualStudioComponent = model.components.find(
    isType(DevCenterComponent.BlocksMainComponent)
  );

  return useCallback(
    (appComponents: AppComponents) => {
      const doesStudioComponentExists = appComponents.some(
        (component) => component.compType === ComponentType.STUDIO
      );

      if (!model.config.blocks || doesStudioComponentExists) {
        return;
      }

      const studioComponent = {
        compId: virtualStudioComponent?.id,
        compType: 'STUDIO',
        compData: {},
        compName: 'studio',
      };

      return [studioComponent];
    },
    [model, virtualStudioComponent]
  );
}
